import { useSessionStore } from '../store/sessionStore';
import './StatusBar.css';

export function StatusBar() {
  const { events, sessions, unacknowledgedAlerts } = useSessionStore();
  const sessionCount = Object.keys(sessions).length;
  const alertCount = unacknowledgedAlerts.length;
  const now = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });

  return (
    <footer className="status-bar">
      <div className="status-bar-left">
        <span className="status-bar-stat">
          <strong>{events.length}</strong> events
        </span>
        <span className="status-bar-sep">·</span>
        <span className="status-bar-stat">
          <strong>{sessionCount}</strong> session{sessionCount !== 1 ? 's' : ''}
        </span>
      </div>

      <div className="status-bar-center">
        {alertCount > 0 && (
          <span className="status-bar-alert pulse">
            {alertCount} active alert{alertCount !== 1 ? 's' : ''}
          </span>
        )}
      </div>

      <div className="status-bar-right">
        <span className="status-bar-time text-dim">{now}</span>
      </div>
    </footer>
  );
}
